const API = "/api/v1/admin/framework";

export class FrameworkApiError extends Error {
  constructor(status, data) {
    super(data?.error || data?.message || `HTTP ${status}`);
    this.status = status;
    this.code = data?.code;
    this.data = data;
  }
}

async function request(path, options = {}) {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    ...options,
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });
  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { error: text };
  }
  if (!response.ok) throw new FrameworkApiError(response.status, data);
  return data;
}

export const frameworkApi = {
  list: (query) => request(query ? `?${new URLSearchParams(query).toString()}` : ""),
  get: (id) => request(`/${encodeURIComponent(id)}`),
  metadata: (id) => request(`/${encodeURIComponent(id)}/metadata`),
  questions: (id, query) => request(`/${encodeURIComponent(id)}/questions?${new URLSearchParams({ paged: "true", ...query }).toString()}`),
  requirements: (id, query) => request(`/${encodeURIComponent(id)}/requirements?${new URLSearchParams({ paged: "true", ...query }).toString()}`),
  diff: (id, against) =>
    request(
      `/${encodeURIComponent(id)}/diff?against=${encodeURIComponent(against)}`,
    ),
  create: (body) => request("", { method: "POST", body }),
  clone: (id) =>
    request(`/${encodeURIComponent(id)}/new-version-from`, {
      method: "POST",
      body: {},
    }),
  update: (id, body) =>
    request(`/${encodeURIComponent(id)}`, { method: "PATCH", body }),
  remove: (id) =>
    request(`/${encodeURIComponent(id)}`, { method: "DELETE", body: {} }),
  publish: (id) =>
    request(`/${encodeURIComponent(id)}/publish`, { method: "POST", body: {} }),
  retire: (id) =>
    request(`/${encodeURIComponent(id)}/retire`, { method: "POST", body: {} }),
  createQuestion: (id, body) =>
    request(`/${encodeURIComponent(id)}/questions`, { method: "POST", body }),
  updateQuestion: (id, questionId, body) =>
    request(
      `/${encodeURIComponent(id)}/questions/${encodeURIComponent(questionId)}`,
      { method: "PATCH", body },
    ),
  removeQuestion: (id, questionId) =>
    request(
      `/${encodeURIComponent(id)}/questions/${encodeURIComponent(questionId)}`,
      { method: "DELETE", body: {} },
    ),
  reorderQuestions: (id, items) =>
    request(`/${encodeURIComponent(id)}/questions/reorder`, {
      method: "PATCH",
      body: { items },
    }),
  createRequirement: (id, body) =>
    request(`/${encodeURIComponent(id)}/requirements`, {
      method: "POST",
      body,
    }),
  reorderRequirements: (id, items) =>
    request(`/${encodeURIComponent(id)}/requirements/reorder`, {
      method: "PATCH",
      body: { items },
    }),
  updateRequirement: (id, requirementId, body) =>
    request(
      `/${encodeURIComponent(id)}/requirements/${encodeURIComponent(requirementId)}`,
      { method: "PATCH", body },
    ),
  removeRequirement: (id, requirementId) =>
    request(
      `/${encodeURIComponent(id)}/requirements/${encodeURIComponent(requirementId)}`,
      { method: "DELETE", body: {} },
    ),
};
